import styles from "./index.module.scss";
import type { GrantedPermission } from "@/types/modular-permissions.types";
import React from "react";
import { type Config, type UseAccountReturnType } from "wagmi";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import type { ModPerms } from "@/features/mod-perms/api/get-all-mod-perms";
import { UseQueryResult } from "@tanstack/react-query";
import ModPermsActionBtns from "@/features/mod-perms/components/buttons/action-btns";
import DelegateCreationCard from "@/features/mod-perms/components/cards/creation-card/delegate-creation-card";
import LoadingIndicatorCard from "@/features/mod-perms/components/cards/loading-card/loading-indicator-card";
import NoPermsExistCard from "@/features/mod-perms/components/cards/no-perms-card/no-perms-card";
import DelegationList from "@/features/mod-perms/components/lists/list";

type Props = {
  connectedAcc: UseAccountReturnType<Config>;
  permissions: GrantedPermission[];
  isLoading: boolean;
  fetchControls: UseQueryResult<ModPerms | null, Error>;
};

const OnChainBlock = ({
  permissions,
  isLoading,
  connectedAcc,
  fetchControls,
}: Props) => {
  const { isDelegateContextGranted, receivedPermissions } =
    useModularPermissionsStore();

  const isConnected = connectedAcc.isConnected;
  const isDelegateGranted = isDelegateContextGranted();
  const hasPermissions = receivedPermissions.length > 0;

  const showModPermsActionBtns =
    (isConnected && isDelegateGranted) ||
    (isConnected && !isDelegateGranted && hasPermissions);

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.headerWrapper}>
        <p className={styles.listHeaderMirrored}>Permissions</p>
        <hr />
      </div>
      {/* <div className={styles.header}>{isDelegateContextGranted() ? "Granted" : "Received"} Permissions</div> */}
      {showModPermsActionBtns && (
        <ModPermsActionBtns fetchControls={fetchControls} />
      )}
      <DelegateCreationCard isLoading={isLoading} />

      {isLoading && <LoadingIndicatorCard />}

      {!isLoading && isConnected && (
        <>
          <DelegationList
            permissions={permissions}
            isLoading={isLoading}
            accountStatus={connectedAcc}
          />
        </>
      )}

      {fetchControls.isFetched && !isLoading && (
        <NoPermsExistCard
          isLoading={isLoading}
          permissions={permissions}
          accountStatus={connectedAcc}
        />
      )}
    </div>
  );
};

export default OnChainBlock;
